<template>
<div id="app">
  <nkn-header></nkn-header>
  <div class="nkn-placeholder"></div>
  <router-view v-if="isRouterAlive"/>
  <nkn-footer></nkn-footer>
  <nkn-chat v-show="showChat" :lang="$i18n.locale" :title="chatTitle" :welcome="$t('welcome')" :topic="chatTopic" :send-label="$t('sendLabel')" />
</div>
</template>

<script>
import nknHeader from '@/components/header/nknHeader'
import nknFooter from '@/components/footer/nknFooter'
import {mapMutations} from 'vuex'
import 'vue-nkn-chat/lib/nknChat.css'
// function traverse () {
//   var arr = []
//   var elements = []
//   elements = document.all

//   for (var i = 0; i < elements.length; i++) {
//     var ele = elements[i]
//     var width = parseFloat(ele.style.width) || ele.offsetWidth
//     if (width > 375) {
//       arr.push(elements[i])
//     }
//   }
//   return arr
// }

export default {
  name: 'App',
  provide: function () {
    return {
      reload: this.reload
    }
  },
  components: {
    nknHeader,
    nknFooter
  },
  data: function () {
    return {
      isRouterAlive: true,
      chatTitle: '',
      chatTopic: '',
      showChat:false
    }
  },
  created () {
    let lang = ''
    if (!!this.$route.params.lang) {
      lang = `${this.$route.params.lang}`
      this.setLang(lang)
    }
    this.initChat()
  },
  mounted () {

    // this.$nextTick(_ => {
    //   console.log(traverse())
    // })
  },
  updated() {
    this.initChat()
  },
  methods: {
    ...mapMutations([
      'setLang'
    ]),
    // 刷新方法
    reload: function () {
      this.isRouterAlive = false
      // 该方法会在dom更新后执行
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    initChat(){
      this.showChat = true
      this.chatTitle = this.$t('chat.service')

      if (this.$route.name === 'ncdn') {
        this.chatTopic = 'ncdn-support.24e9f5fb662931f93763a6ff40e58dba385159e9316141532f8b70645c643947'
      } else if (this.$route.name === 'dataride') {
        this.chatTopic = 'dataride-support.24e9f5fb662931f93763a6ff40e58dba385159e9316141532f8b70645c643947'
      } else {
        this.chatTopic = 'nkn-support.24e9f5fb662931f93763a6ff40e58dba385159e9316141532f8b70645c643947'
      }

    }
  },
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .nkn-placeholder{
    height: 48px;
  }
}
</style>

<style>
  a:hover {
    color: inherit !important;
    text-decoration: underline;
    cursor: pointer;
  }

  .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue